export class EventQueue {
  constructor(maxSize = 20) {
    this.maxSize = maxSize
    this.events = []
  }

  add(event) {
    this.events.push(event)
    return this.isFull()
  }

  isFull() {
    return this.events.length >= this.maxSize
  }

  flush() {
    const batch = [...this.events]
    this.events = []
    return batch
  }

  size() {
    return this.events.length
  }

  isEmpty() {
    return this.events.length === 0
  }

  restore(events) {
    this.events = [...events, ...this.events]
  }
}
